import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Kbd — keyboard shortcut chip. Used in tooltips, command palette, menus.
 */
export const Kbd = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, children, ...props }, ref) => (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex items-center gap-[2px] rounded-sm border border-ia-border bg-ia-elevated',
        'px-[6px] h-5 text-[10px] font-mono font-semibold text-ia-text-secondary',
        'shadow-[0_1px_0_var(--color-ia-border)]',
        className,
      )}
      {...props}
    >
      {children}
    </kbd>
  ),
)
Kbd.displayName = 'Kbd'
